import { createBrowserRouter } from "react-router-dom";
import { lazy, Suspense } from "react";

const App = lazy(() => import("../App"));
const HomePageMain = lazy(() => import("../pages/homePage/HomePageMain"));
const ContactMain = lazy(() => import("../pages/contact/ContactMain"));
const AboutUs = lazy(() => import("../pages/aboutUs/AboutUs"));
const SolutionDetail = lazy(() => import("../pages/solutions/SolutionDetail"));
const ProductMain = lazy(() => import("../pages/product/ProductMain"));
const IntegrationsPage = lazy(() => import("../pages/integrations/IntegrationsPage"));
const IndustryMain = lazy(() => import("../pages/industry/IndustryMain"));
const CaseStudyListingMain = lazy(() => import("../pages/caseStudy/CaseStudyListingMain"));
const CaseStudyDetailMain = lazy(() => import("../pages/caseStudy/caseStudyDetail/CaseStudyDetailMain"));
const NewCaseStudyDetailMain = lazy(() => import("../pages/caseStudyDetail/CaseStudyDetailMain"));
const BlogMain = lazy(() => import("../pages/blog/BlogMain"));
const BlogDetail = lazy(() => import("../pages/blog/blogDetail/BlogDetail"));
const AllSolutionsMain = lazy(() => import("../pages/AllSolutions/AllSolutionsMain"));
const MainService = lazy(() => import("../pages/services/MainService"));
const MainLegal = lazy(() => import("../pages/legal/MainLegal"));
const CareersMain = lazy(() => import("../pages/careers/CareersMain"));
const JobsMain = lazy(() => import("../pages/careers/JobsMain"));
const NotFound = lazy(() => import("../pages/NotFound"));

// Loader component
const PageLoader = () => (
  <div className="flex min-h-screen items-center justify-center bg-white">
    <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary-100 border-t-primary-600" />
  </div>
);

// Helper wrapper
const withSuspense = (Component) => (
  <Suspense fallback={<PageLoader />}>
    <Component />
  </Suspense>
);

const AppRouter = createBrowserRouter([
  {
    path: "/",
    element: withSuspense(App),
    children: [
      {
        index: true,
        element: withSuspense(HomePageMain),
      },
      {
        path: "/contact",
        element: withSuspense(ContactMain),
      },
      {
        path: "/about-us",
        element: withSuspense(AboutUs),
      },
      {
        path: "/careers",
        element: withSuspense(CareersMain),
      },
      {
        path: "/careers/jobs",
        element: withSuspense(JobsMain),
      },
      {
        path: "/solutions",
        element: withSuspense(AllSolutionsMain),
      },
      {
        path: "/solutions/:slug",
        element: withSuspense(SolutionDetail),
      },
      {
        path: "/products/:slug",
        element: withSuspense(ProductMain),
      },
      {
        path: "/services/:slug",
        element: withSuspense(MainService),
      },
      {
        path: "/legal/:slug",
        element: withSuspense(MainLegal),
      },
      {
        path: "/integrations/:slug",
        element: withSuspense(IntegrationsPage),
      },
      {
        path: "/industries",
        element: withSuspense(IndustryMain),
      },
      { path: "/case-studies", element: withSuspense(CaseStudyListingMain) },
      {
        path: "/case-studies/:slug",
        element: withSuspense(CaseStudyDetailMain),
      },
      {
        path: "/case-study/:slug",
        element: withSuspense(NewCaseStudyDetailMain),
      },
      { path: "/blog", element: withSuspense(BlogMain) },
      { path: "/blog/:slug", element: withSuspense(BlogDetail) },
      { path: "/blog-detail/:slug", element: withSuspense(BlogDetail) },
    ],
  },
  {
    path: "*",
    element: withSuspense(NotFound),
  },
]);

export default AppRouter;
